import { render } from "./AdminProducts.vue?vue&type=template&id=1e806760&scoped=true"
import script from "./AdminProducts.vue?vue&type=script&lang=js"
export * from "./AdminProducts.vue?vue&type=script&lang=js"

import "./AdminProducts.vue?vue&type=style&index=0&id=1e806760&scoped=true&lang=css"

import exportComponent from "/Users/LeonardoMBP/Documents/GitHub/swagible-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e806760"]])

export default __exports__